import { Fragment, useEffect, useState } from 'react';
import Select from "react-select";
import { Formik } from "formik";
import * as Yup from "yup";

const groups = [
  { value: 'global', label: 'Global Travel Group', color: '#00B8D9' },
  { value: 'ite', label: 'Independent Travel Experts', color: '#0052CC' },
  { value: 'tta', label: 'TTA', color: '#5243AA' },
  { value: 'worldchoice', label: 'Worldchoice', color: '#5243AA' },
  { value: 'worldchoice-plus', label: 'Worldchoice +', color: '#5243AA' },
  { value: 'other', label: 'Other', color: '#5243AA' },
];

const Organisation = ({ state, updateState, nextStep, previousStep }) => {
  const [isNewMember, setIsNewMember] = useState(state?.data?.ttng?.is_new_member || false);

  useEffect(() => {
    if (!state?.data?.company_information?.industry_bodies.includes('ttng')) {
      if (state.stepDirection === 'next') {
        nextStep();
      } else {
        previousStep();
      }
    }
  }, [state]);

  const initialValues = {
    group: state?.data?.ttng?.group || '',
  };

  const validations = {
    group: Yup
      .string()
      .required('Group is required'),
  };

  if (isNewMember === false) {
    initialValues.membership_number = state?.data?.ttng?.membership_number || '';
    validations.membership_number = Yup.string().required('Membership Number is required');
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object().shape(validations)}
      onSubmit={async (values, {
        setSubmitting
      }) => {
        setSubmitting(true);
        updateState('ttng', {
          ...values,
          is_new_member: isNewMember,
        });
        nextStep();
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
        setFieldValue,
      }) => (
        <Fragment>
          <form action="#" method="POST" onSubmit={handleSubmit}>

            <h1 className="text-2xl font-semibold mb-6">TTNG Membership</h1>

            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">

              <div className="gap-x-4 sm:col-span-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Are you a new member of TTNG?
                </label>
                <div className="mt-2.5 clear">
                  <ul
                    className="items-center w-full text-sm font-medium text-gray-900 bg-white border rounded-lg sm:flex bg-gray-100 border-gray-300">
                    <li
                      oncClick={() => setIsNewMember(false)}
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300 cursor-pointer">
                      <div className="flex items-center cursor-pointer">
                        <input id="horizontal-list-radio-license" type="radio" value="" name="list-radio" checked={isNewMember === false} onChange={() => setIsNewMember(false)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 bg-gray-500 border-gray-300" />
                        <label htmlFor="horizontal-list-radio-license"
                          className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">No</label>
                      </div>
                    </li>
                    <li
                      onClick={() => setIsNewMember(true)}
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300 cursor-pointer">
                      <div className="flex items-center cursor-pointer">
                        <input id="horizontal-list-radio-id" type="radio" value="" name="list-radio" checked={isNewMember === true} onChange={() => setIsNewMember(true)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 border-gray-300" />
                        <label htmlFor="horizontal-list-radio-id"
                          className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">Yes</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              {isNewMember === false && (
                <div className="sm:col-span-2 mb-2">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                    TTNG Membership Number *
                  </label>
                  <div className="mt-2.5">
                    <input type="text"
                      name="membership_number"
                      id="membership_number"
                      value={values.membership_number}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      autoComplete="organization"
                      placeholder={'e.g. X1234'}
                      className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.membership_number && errors.membership_number ? ' border-red-500' : ''}`}
                    />
                    {touched.membership_number && errors.membership_number && <div className="field-error">{errors.membership_number}</div>}
                  </div>
                </div>
              )}

              <div className="sm:col-span-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Which group are you a member of? *
                </label>
                <div className="mt-2.5">
                  <Select
                    name="group"
                    value={values.group !== '' ? groups.find(option => option.value === values.group) : ''}
                    options={groups}
                    onChange={(value) => setFieldValue('group', value.value)}
                    className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-1 px-2 pr-2 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.group && errors.group ? ' border-red-500' : ''}`}
                    classNamePrefix="select"
                  />
                  {touched.group && errors.group && <div className="field-error">{errors.group}</div>}
                </div>
              </div>

            </div>

            <div className="mt-12">
              <button type="submit"
                className="bg-purple-800 disabled:bg-purple-200 hover:bg-purple-900 text-white font-semibold rounded-md py-2 px-4 w-full">
                Next
              </button>
            </div>

            <div className="mt-4">
              <button type="button"
                onClick={previousStep}
                className="block w-full rounded-md bg-slate-300 px-3.5 py-2.5 text-center text-md font-semibold text-black shadow-sm hover:text-white hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600">
                Previous
              </button>
            </div>
          </form>
        </Fragment>
      )}
    </Formik>
  );
}

export default Organisation;
